import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOpensourceinitiativeComponent } from './simple-icons-opensourceinitiative.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOpensourceinitiativeComponent ],
    exports:      [ SimpleIconsOpensourceinitiativeComponent ],
    bootstrap:    []
})
export class SimpleIconsOpensourceinitiativeModule {}
